module.exports = __webpack_public_path__ + "img/1-4.59e487fc.svg";